/**
 * <s-order-fields> keeps typed vehicle-info answers when the product form partial
 * re-renders on variant change, by caching them in sessionStorage per product.
 */
class SOrderFields extends HTMLElement {
  #ac;

  get #storageKey() {
    return `order-fields:${this.dataset.productId || ''}`;
  }

  connectedCallback() {
    this.#ac = new AbortController();
    this.#restore();
    this.addEventListener('input', () => this.#save(), { signal: this.#ac.signal });
    this.addEventListener('change', () => this.#save(), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #fields() {
    return Array.from(this.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]'));
  }

  #save() {
    const values = {};
    for (const field of this.#fields()) values[field.name] = field.value;
    try {
      sessionStorage.setItem(this.#storageKey, JSON.stringify(values));
    } catch {
      // Storage unavailable; answers just won't survive a variant change.
    }
  }

  #restore() {
    let values = null;
    try {
      values = JSON.parse(sessionStorage.getItem(this.#storageKey) || 'null');
    } catch {
      values = null;
    }
    if (!values) return;
    for (const field of this.#fields()) {
      if (typeof values[field.name] === 'string' && !field.value) field.value = values[field.name];
    }
  }
}

if (!customElements.get('s-order-fields')) customElements.define('s-order-fields', SOrderFields);
